import React from "react";
import { LeadArchiveTable } from "./overview/LeadArchiveTable";
import { OverviewContainer } from "../../common/OverviewContainer";

export function LeadArchiveOverview() {
  return (
    <OverviewContainer title={null}>
      <LeadArchiveTable />
    </OverviewContainer>
  );
}
